export const faqs = [
  {
    q: '瓜田笔记里的故事都是真实发生的吗？',
    a: '我们收录的故事来自读者投稿与编辑整理，会保留真实校园生活的质感，同时对涉及个人隐私的信息做脱敏处理，人物姓名、院系与地点均经过模糊化，请在阅读时把它当作身边可能发生的故事。',
  },
  {
    q: '我可以投稿自己的校园吃瓜经历吗？',
    a: '当然可以。把故事发送到投稿邮箱 story@guatian-notes.com，附上大致的时间、场景和你想表达的感受即可。编辑会在一周内回复，合适的投稿会安排发布，并标注为读者来稿。',
  },
  {
    q: '网站上的分类分别对应哪些内容？',
    a: '目前分成宿舍夜聊、课堂八卦、社团趣事、食堂奇遇、校园奇闻五个板块，分别面向住宿生活、课堂氛围、社团活动、餐饮日常与校园角落里的各种见闻，你可以直接按分类筛选感兴趣的内容。',
  },
  {
    q: '订阅每日热瓜会收到什么？',
    a: '订阅后我们会在每个工作日的早间发送一封简短邮件，包含当天最值得一读的一到两篇趣闻，以及最近的话题榜单。如果哪天没有值得推送的内容，我们宁愿不发，也不会为了数量打扰你。',
  },
  {
    q: '内容里会不会出现真实的学校名称或具体人物？',
    a: '不会。我们坚持三条内容原则：模糊化个人信息、不指向具体学校、不传播未经核实的负面指控。所有故事的处理重点，都是那些让人会心一笑或有所触动的校园瞬间。',
  },
];